<template>
  <v-app>
    <Nav />
    <v-alert
      v-if="alert.type === 'success'"
      :value="true"
      type="success"
      dismissible
      style="top: 60px; position: fixed; width: 100%; z-index: 999;"
    >
      {{alert.message}}
    </v-alert>
    <v-alert
      v-if="alert.type === 'error'"
      :value="true"
      type="error"
      dismissible
      style="top: 60px; position: fixed; width: 100%; z-index: 999;"
    >
      {{alert.message}}
    </v-alert>
    <router-view></router-view>
  </v-app>
</template>

<script>
import Nav from './Navigation'
export default {
  components: {
    Nav
  },
  name: 'app',
  computed: {
    alert () {
      return this.$store.state.alert
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/app/App.vue